import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@calendly/ui/components/dropdown-menu';
import { IconCheck } from '@calendly/ui/components/glyphs/IconCheck';
import { IconLanguage } from '@calendly/ui/components/glyphs/IconLanguage';
import { ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useCallback, useState } from 'react';
import { useHoverOpenMenu } from '../hooks/use_hover_open_menu';
const menuRowCss = "mstnfuu";
const rowLabelCss = "r1w2vd15";

// Fully independent DropdownMenu, not a DropdownSubmenu nested in the kebab's own menu - same
// shape/bug as event_color_menu.js: CUI's docs warn submenus aren't fully supported for
// selection-list content like this, and nesting it let the kebab's auto-close-on-select and
// outside-click detection race the locale commit and drop it.
//
// Like color, the selected locale is a draft form value (see merge_initial_values.js /
// root_form.js): the parent confirms a picked locale before staging it for the next save, so
// there's no in-flight mutation to gate the options on.
//
// `menuPortalRoot` must be the same node the kebab's own DropdownMenu uses (threaded through from
// header_more_menu.js), so both Popovers portal into one shared container - otherwise the kebab
// treats a click in this (separately-portaled) flyout as an outside click and closes before the
// locale commits.
export const PageLanguageMenu = ({
  activeLocale,
  availableLocales,
  onSelectLocale,
  onLocaleSelected,
  menuPortalRoot
}) => {
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  // See use_hover_open_menu.js for the open/close behavior.
  const {
    triggerProps,
    contentProps
  } = useHoverOpenMenu({
    isOpen: isLanguageMenuOpen,
    onOpen: useCallback(() => setIsLanguageMenuOpen(true), []),
    onClose: useCallback(() => setIsLanguageMenuOpen(false), [])
  });
  const handleSelectLocale = identifier => {
    onSelectLocale(identifier);
    setIsLanguageMenuOpen(false);
    onLocaleSelected?.();
  };
  return <DropdownMenu isOpen={isLanguageMenuOpen} onClose={() => setIsLanguageMenuOpen(false)} menuPortalRoot={menuPortalRoot}>
      <DropdownMenuTrigger>
        <BareButton className={menuRowCss} onClick={() => setIsLanguageMenuOpen(isOpen => !isOpen)} {...triggerProps} data-testid="header-more-menu-page-language-trigger">
          <span className={rowLabelCss}>
            <UiIcon icon={IconLanguage} size="small" title="" />
            {I18n.t('publisher.event_type_editor_crud.header.kebab.page_language')}
          </span>
          {/* Manually added: CUI only renders this automatically for a real DropdownSubmenu. */}
          <ArrowChevronRightMiniIcon />
        </BareButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent placement="right top" {...contentProps}>
        {availableLocales.map(({
        identifier,
        title
      }) => <DropdownMenuItem key={identifier} onSelect={() => handleSelectLocale(identifier)} data-testid={`header-more-menu-locale-${identifier}`}>
            <span className={menuRowCss}>
              {title}
              {identifier === activeLocale && <UiIcon icon={IconCheck} size="small" title="" />}
            </span>
          </DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>;
};

require("./page_language_menu.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./page_language_menu.js");